
export const FormTextInput = ({
    label,
    name,
    value,
    type,
    placeholder,
    required = false,
    onChange,
    validFeedback,
    invalidFeedback,
}) => {
    
    const display = invalidFeedback?.length > 0 ? 'd-block' : 'd-none';

    return (
        <div className="py-2">
            {label && <label htmlFor={name} className="form-label">{label}</label>}
            <input
                id={name}
                type={type}
                name={name}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                required={required}
                className={`form-control`}
            />
                <div className="valid-feedback">
                    {validFeedback}
                </div>
                <div className={`invalid-feedback ${display}`}>
                    {invalidFeedback}
                </div>
        </div>
    )
}
